import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getConfig, isConfigLoaded } from "@/config/config";

const REDIRECT_URI = `${window.location.origin}/auth/callback`;
const POST_LOGOUT_URI = `${window.location.origin}/`;

let userManager: UserManager | null = null;

/**
 * Returns a singleton UserManager configured against the Keycloak realm.
 * Requires loadConfig() to have been called first.
 */
export function getUserManager(): UserManager {
  if (!userManager) {
    if (!isConfigLoaded()) {
      throw new Error(
        "Configuration not loaded. Call loadConfig() before getUserManager().",
      );
    }
    const cfg = getConfig();
    userManager = new UserManager({
      authority: cfg.keycloakAuthority,
      client_id: cfg.keycloakClientId,
      redirect_uri: REDIRECT_URI,
      post_logout_redirect_uri: POST_LOGOUT_URI,
      response_type: "code",
      scope: "openid profile email",
      // Skip Keycloak login form — redirect straight to Entra IdP.
      // Keycloak 26's authenticateByDefault on OIDC providers does not
      // auto-redirect reliably; kc_idp_hint is the supported mechanism.
      extraQueryParams: { kc_idp_hint: "microsoft-entra" },
      // Point the silent-renew iframe at a static HTML file that posts
      // the OIDC response back to the parent frame via postMessage.
      // The .html suffix ensures Vite/nginx serves the file directly
      // instead of falling through to the SPA index.html.
      automaticSilentRenew: true,
      silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
    });
  }
  return userManager;
}
